import { defineMessages, useIntl } from 'react-intl';
import { Flag } from '@packages/shared';
import { HintPanel } from '../HintPanel';

const messages = defineMessages({
  Co2CompensationFlagStandard: {
    id: 'Co2CompensationFlag.standard',
    defaultMessage: '{flag} durch Kompensation',
  },
  Co2CompensationFlagHint: {
    id: 'Co2CompensationFlag.hint',
    defaultMessage: 'Co2-neutral',
  },
});

export const Co2CompensationFlag: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <HintPanel sx={{ p: '1.5', textAlign: 'left' }} typography="body2">
      {formatMessage(messages.Co2CompensationFlagStandard, {
        flag: <Flag type="sustainability" text={formatMessage(messages.Co2CompensationFlagHint)} />,
      })}
    </HintPanel>
  );
};
